import {User} from "./user.model";

export class Users {
  items?: User[];
  totalElements?: number;
  totalPages?: number
}
